import styled, { css } from 'styled-components';

import { IconButton } from '../../../../../components';
import ZIndexLayers from '../../../../../services/ZIndexLayers';
import { ThemeProp } from '../../../../../theme/Themes';

interface HorizontalCarouselContainerProps {
  $isLeftOverlayVisible: boolean;
  $isRightOverlayVisible: boolean;
}

const gradientOverlayCommonStyles = css`
  content: '';
  position: absolute;
  top: 0;
  height: 100%;
  width: 3rem;
  z-index: ${ZIndexLayers.overlay};
`;

interface HorizontalCarouselContainerProps {
  $gradient?: string;
}

export const HorizontalCarouselContainer = styled.div<HorizontalCarouselContainerProps>`
  display: flex;
  gap: 0.5rem;
  overflow: auto;
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }

  &::before {
    display: ${({ $isLeftOverlayVisible }: HorizontalCarouselContainerProps) =>
      $isLeftOverlayVisible ? null : 'none'};
    ${gradientOverlayCommonStyles};
    background: ${(props: HorizontalCarouselContainerProps & ThemeProp) =>
      props.$gradient ?? props.theme.gradients.horizontalOverflowGradient};
    transform: rotate(180deg);
    left: 0;
  }

  &::after {
    display: ${({ $isRightOverlayVisible }: HorizontalCarouselContainerProps) =>
      $isRightOverlayVisible ? null : 'none'};
    ${gradientOverlayCommonStyles};
    background: ${(props: HorizontalCarouselContainerProps & ThemeProp) =>
      props.$gradient ?? props.theme.gradients.horizontalOverflowGradient};
    right: 0;
  }
`;

interface ScrollButtonProps {
  $isVisible: boolean;
}

const commonScrollButtonProps = css`
  position: absolute;
  top: 50%;
  width: 1.5rem;
  height: 1.5rem;
  z-index: ${ZIndexLayers.overlay + 1};
  border: 1px solid ${({ theme }: ThemeProp) => theme.colors.neutrals.c200};
  opacity: 0;

  &:hover {
    opacity: 1;
  }

  svg,
  path {
    stroke: ${({ theme }: ThemeProp) => theme.colors.neutrals.c500};
  }
`;

export const LeftScrollButton = styled(IconButton)<ScrollButtonProps>`
  ${commonScrollButtonProps}
  left: 0;
  ${({ $isVisible }) => (!$isVisible ? 'display: none' : null)};
  transform: translateY(-50%) rotate(90deg);
`;

export const RightScrollButton = styled(IconButton)<ScrollButtonProps>`
  ${commonScrollButtonProps};
  right: 0;
  ${({ $isVisible }) => (!$isVisible ? 'display: none' : null)};
  transform: translateY(-50%) rotate(270deg);
`;
